import React from "react";
import { Grid, Paper, TextField } from "@mui/material";

export default function NameField({ register, classes, errors }) {
  return (
    <Paper elevation={0}>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{ borderBottom: 1, borderColor: "#F2F3F4" }}
      >
        <Grid
          item
          xs={4}
          sm={2.5}
          sx={{ fontWeight: "bold", p: "20px", pl: "20px" }}
        >
          氏名
        </Grid>
        <Grid item xs={8} sm={9.5} sx={{ p: "20px", pl: "15px" }}>
          <TextField
            sx={classes}
            variant="standard"
            required
            type="text"
            {...register("name")}
            error={Boolean(errors?.name)}
            helperText={errors?.name?.message}
            fullWidth
            id="name"
            InputProps={{
              disableUnderline: true,
              style: { fontSize: 16 },
            }}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}